import AlertBanner from "@pathwright/ui/src/components/alert/AlertBanner"
import { getEnv, getIsLocalDev } from "@pathwright/ui/src/components/utils/env"
import { usePathwrightContext } from "@pathwright/features/src/modules/pathwright/PathwrightContext"
import get from "lodash/get"

const StagingPreviewAlert = ({ forceShow = false }) => {
  const { me } = usePathwrightContext()
  const isPWStaff = get(me, "permissions.has_pathwright_staff_access")
  // Hiding alert for now.
  const hideAlert = true || getEnv("production") || getIsLocalDev() || isPWStaff
  forceShow = forceShow && !getEnv("production")

  if (hideAlert && !forceShow) return null

  return (
    <AlertBanner.Banner
      icon="eye"
      message="Viewing Pathwright Preview Server"
      alertType="info"
      actionIcon="external-link"
      brand
      target="_blank"
      label="Learn More"
      href="https://help.pathwright.com/en/articles/5167187-how-to-preview-seasonal-feature-releases"
    />
  )
}

export default StagingPreviewAlert
